
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Validators } from '@angular/forms';
import { LoginService } from '../../login/login.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { ContractsService } from '../_services/contracts.service';
import { Contract } from '../_types/contract';
import { ContractZonesService } from '../_services/contracts-zones.service';
import { ContractZonesDetailComponent } from './zones-detail/zones-detail.component';
import { ContractZone } from '../_types/contract-zone';
import { ContractCapabilitiesService } from '../_services/contracts-capabilities.service';
import { ContractProcessor } from '../_types/contract-processor';
import { ContractProcessorsService } from '../_services/contracts-processors.service';
import { ContractProcessorsDetailComponent } from './processors-detail/processors-detail.component';
import { BusinessBankAccountsService } from '../../business/_services/business-bank-accounts.service';
import { BusinessBankAccount } from '../../business/_types/business-bank-account';
import { Business } from '../../business/_types/business';
import { BusinessService } from '../../business/_services/business.service';
import { PaymentMethod } from '../../common/_types/payment-method';
import { PaymentsMethodsService } from '../../common/_services/payments-methods.service';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ContractCapabilitiesDetailComponent } from './capabilities-detail/capabilities-detail.component';
import { ContractCapability } from '../_types/contract-capability';
import { ContractSla } from '../_types/contract-sla';
import { ContractSlasService } from '../_services/contracts-slas.service';
import { ContractSlasDetailComponent } from './slas-detail/slas-detail.component';
import { ContractMailAccountsService } from '../_services/contracts-mails-accounts.service';
import { ContractMailAccount } from '../_types/contract-mail-account';
import { ContractMailAccountsDetailComponent } from './mails-detail/mails-detail.component';
import { CompanyRatesService } from '../_services/companies-rates.service';
import { ContractWorkersService } from '../_services/contracts-workers.service';
import { ContractWorkersDetailComponent } from './workers-detail/workers-detail.component';
import { ContractWorker } from '../_types/contract-worker';
import { ContractInboundPhone } from '../_types/contract-inbound-phone';
import { ContractInboundPhonesService } from '../_services/contracts-inbound-phones.service';
import { ContractInboundPhoneDetailComponent } from './inbound-phone-detail/inbound-phone-detail.component';
import { ContractOutboundPhone } from '../_types/contract-outbound-phone';
import { ContractOutboundPhonesService } from '../_services/contracts-outbound-phones.service';
import { ContractOutboundPhoneDetailComponent } from './outbound-phone-detail/outbound-phone-detail.component';
import { ContractCaseLog } from '../_types/contract-case-log';
import { ContractCaseLogsService } from '../_services/contracts-case-logs.service';
import { ContractCaseLogDetailComponent } from './case-log-detail/case-log-detail.component';
import { CaseLogType } from '../../cases/_types/case-log-type';
import { CaseLogTypesService } from '../../cases/_services/cases-log-types.service';
import { ContractCaseLogType } from '../_types/contract-case-log-type';
import { ContractCaseLogsTypesService } from '../_services/contracts-case-logs-types.service';
import { CostCentersService } from '../../costs-center/_services/costsCenters.service';
import { CostCenter } from '../../costs-center/_types/costCenter';
import { ContractTransactionSeriesService } from '../_services/contracts-transactions-series.service';
import { ContractTransactionSerie } from '../_types/contract-transaction-serie';
import { ContractTransactionSeriesDetailComponent } from './transaction-series-detail/transaction-series-detail.component';
import { Integration } from '../_types/integration';
import { IntegrationField, IntegrationFieldGroup, emptyMailAccountValue } from '../_types/integration-field';
import { IntegrationsService } from '../_services/integrations.service';
import { UsersService } from '../../users/_services/users.service';
import { CaseTypeProcessorContract } from '../../cases-types/_types/case-type-processor-contract';
import { CasesTypesProcessorContractsService } from '../../cases-types/_services/cases-types-processors-contracts.service';
import { ContractInboundMail } from '../_types/contract-inbound-mail';
import { ContractInboundMailsService } from '../_services/contracts-inbound-mails.service';
import { ContractInboundMailDetailComponent } from './inbound-mail-detail/inbound-mail-detail.component';
import { CasesTypesService } from '../../cases-types/_services/cases-types.service';
import { ContractCaseTypesService } from '../_services/contracts-case-types.service';
import { ContractCaseType } from '../_types/contract-case-type';
import { OutgoingMailDetailComponent } from './outgoing-mail-detail/outgoing-mail-detail.component';
import { ContractOutgoingMail } from '../_types/contract-outgoing-mail';
import { ContractOutgoingMailsService } from '../_services/contracts-outgoing-mails.service';
import { CasesModesService } from '../../cases/_services/cases-modes.service';
import { CompanyCaseModeService } from '../_services/company-case-mode.service';

@Component({
    selector: 'app-contracts-detail',
    templateUrl: './contracts-detail.component.html',
    styleUrls: ['./contracts-detail.component.css'],
    standalone: false
})
export class ContractsDetailComponent implements OnInit {

  public contractFormGroup!: RxFormGroup;

  public contract: Contract = new Contract();
  public loading: boolean = false;
  public activeIndex: number = 1;
  public allowWrite: boolean = false;
  public allowWriteProcessors: boolean = false;
  public allowDelete: boolean = false;
  public allowDeleteProcessors: boolean = false;
  public caseTrackingChannels: any[] = [
    { label: 'No enviar', value: 'None' },
    { label: 'Enviar por SMS', value: 'SMS' },
    { label: 'Enviar por WhatsApp', value: 'Whatsapp' }
  ];
  public contractZones: Array<ContractZone> = new Array<ContractZone>();
  public contractProcessors: Array<ContractProcessor> = new Array<ContractProcessor>();
  private pendingProcessors: Array<{ processor: ContractProcessor, caseTypeIds: string[], caseTypes: any[] }> = [];
  public contractWorkers: Array<ContractWorker> = new Array<ContractWorker>();
  public contractCapabilities: Array<ContractCapability> = new Array<ContractCapability>();
  public contractTransactionSeries: Array<ContractTransactionSerie> = new Array<ContractTransactionSerie>();
  public contractInboundPhones: Array<ContractInboundPhone> = new Array<ContractInboundPhone>();
  public contractOutboundPhones: Array<ContractOutboundPhone> = new Array<ContractOutboundPhone>();
  public contractInboundMails: Array<ContractInboundMail> = new Array<ContractInboundMail>();
  public contractOutgoingMails: Array<ContractOutgoingMail> = new Array<ContractOutgoingMail>();
  public contractSlas: Array<ContractSla> = new Array<ContractSla>();
  public contractMailAccounts: Array<ContractMailAccount> = new Array<ContractMailAccount>();
  public totalCapabilitiesRecords: number = 0;
  public totalTransactionSeriesRecords: number = 0;
  public totalContractInboundPhonesRecords: number = 0;
  public totalContractOutboundPhonesRecords: number = 0;
  public totalContractInboundMailsRecords: number = 0;
  public totalContractCaseLogsRecords: number = 0;
  public billingCompaniesBanksAccounts: Array<BusinessBankAccount> = new Array<BusinessBankAccount>();
  public paymentsMethods: Array<PaymentMethod> = new Array<PaymentMethod>();
  public billingCompanies: Array<Business> = new Array<Business>();
  public companyId: string = "";
  public rates: any = [];
  public totalRatesRecords: number = 0;
  public caseLogTypes: CaseLogType[] = [];
  public caseLogTypesContract: ContractCaseLogType[] = [];
  public displaycaseLogType:  boolean = false;
  public caseLogTypesFiltered: CaseLogType[] = [];
  public caseLogTypeId: string = "";
  //edición del formulario propio del contrato para un tipo de evento
  public displayCaseLogTypeFields: boolean = false;
  public caseLogTypeFieldsEdit: ContractCaseLogType | null = null;
  public caseLogTypeFieldsConfiguration: string = "";
  //mismo permiso que en la ficha de la categoría: sin él no se ve ni la columna ni el editor
  public allowCaseLogTypeFields: boolean = false;
  public costsCenters: CostCenter[] = [];
  public invoiceModes: { name: string, id: string }[] = [
    { name: 'Albaranes', id: 'outgoing_delivery' },
    { name: 'Facturas', id: 'invoice' },
  ];
  public targetOptions: { name: string, id: string }[] = [
    { name: 'Cliente', id: 'Client' },
    { name: 'Compañía', id: 'Company' }
  ];
  public integrations: Integration[] = [];
  public integration_config: IntegrationField[] = [];
  public integration_groups: IntegrationFieldGroup[] = [];
  public localModel: any = {
  };
  public users: any = [];
  public contracsProcessorsCasessTypes: any = [];
  public totalZonesRecords: number = 0;
  public totalContractCaseTypesRecords: number = 0;
  public contractCaseTypes: any = [];

  constructor(
    private businessService: BusinessService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private contractsService: ContractsService,
    private contractZonesService: ContractZonesService,
    private contractProcessorsService: ContractProcessorsService,
    private contractSlasService: ContractSlasService,
    private contractMailAccountsService: ContractMailAccountsService,
    private dialogService: DialogService,
    private contractCapabilitiesService: ContractCapabilitiesService,
    private contractWorkersService: ContractWorkersService,
    private businessBankAccountsService: BusinessBankAccountsService,
    private paymentsMethodsService: PaymentsMethodsService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private companyRatesServices: CompanyRatesService,
    private contractInboundPhonesService: ContractInboundPhonesService,
    private contractOutboundPhonesService: ContractOutboundPhonesService,
    private contractInboundMailsService: ContractInboundMailsService,
    private contractOutgoingMailService: ContractOutgoingMailsService,
    private caseLogTypesService: CaseLogTypesService,
    private contractCaseLogsTypesService: ContractCaseLogsTypesService,
    private costCentersService: CostCentersService,
    private contractTransactionSeriesService: ContractTransactionSeriesService,
    private integrationService: IntegrationsService,
    private usersService: UsersService,
    private casesTypesProcessorContractsService: CasesTypesProcessorContractsService,
    private casesTypesService: CasesTypesService,
    private contractCaseTypesService: ContractCaseTypesService,
    private casesModesService: CasesModesService,
    private companyCaseModeService: CompanyCaseModeService
  ) {
    this.contractFormGroup = this.formBuilder.formGroup<Contract>(this.contract) as RxFormGroup;
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Detalles de contrato");
    this.topbarService.addBreadcrumb("Compañías", "/companies");

    this.route.paramMap.subscribe((params: ParamMap) => {
      let companyId: string = params.get('id')!;
      let contractId: string | null = params.get('contractId');
      this.contract.companyId = companyId;
      if (contractId != null && contractId != '0') {
        this.loadContract(contractId);
      }
      else {
        this.loadCostCenters()
      }

      this.topbarService.addBreadcrumb("Detalles de compañía aseguradora", "/companies/" + params.get('id'));
      this.loadBillingCompanies();

    });    
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
    this.allowDeleteProcessors = this.loginService.hasPermission("COMPANIES.DELETE_PROCESSORS");
    this.allowCaseLogTypeFields = this.loginService.hasPermission("CASES_LOGS_TYPES.FIELDS_CONFIGURATION");
    //this.allowWriteProcessors = this.loginService.hasPermission("COMPANIES.WRITE_PROCESSORS");

    this.loadPaymentsMethods();

  }

  private setDefaultTargetByCompanyMode(hasSeriousSinisterMode: boolean) {
    const targetControl = this.contractFormGroup.get('target');
    if (!targetControl) {
      return;
    }

    // Only set automatic default for new contracts and only while user has not changed it.
    if (this.contract.id || targetControl.dirty) {
      return;
    }

    const defaultTarget = hasSeriousSinisterMode ? 'Client' : 'Company';
    this.contract.target = defaultTarget;
    targetControl.patchValue(defaultTarget, { emitEvent: false });
  }

  async loadContract(id: string) {
    this.contract = await firstValueFrom(this.contractsService.get(id));
    this.contractFormGroup.patchValue(this.contract);
    this.localModel = this.parseIntegrationConfig(this.contract.integrationConfig);
    //loadIntegrations() es asincrono: hasta que no resuelva y llame a changeIntegration() no sabemos
    //que campos toca pintar. Si dejamos aqui los del contrato anterior, la plantilla lee claves que
    //ya no estan en el localModel recien cargado y revienta el render de toda la ficha
    this.integration_config = [];
    this.integration_groups = [];

    this.loadContractWorkers();
    this.loadContractSlas();
    this.loadContractMailAccounts();
    this.loadContractTransactionSeries();
    this.loadBillingCompaniesBankAccounts();    
    this.loadRates();
    this.loadContractInboundPhones();
    this.loadContractOutboundPhones();
    this.loadContractInboundMails();
    this.loadContractOutgoingMails();
    this.loadCasesLogsTypes();
    this.loadCostCenters();
    this.loadIntegrations();
    this.loadUsers();

  }

async onTabChange(event: any) {
  if(event.index == 1){
    this.loadContractCapabilities();
  }else if(event.index == 2){
    this.loadContractZones();
  }else if(event.index == 3){
    this.loadContractProcessors();
  }else if(event.index == 10){
    this.loadCasesTypes();

  }
}

  async loadContractZones() {

    let filters = {
      companyId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      page: { size: 0 },
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['zone']
    };

    let response = await firstValueFrom(this.contractZonesService.all(params));
    this.contractZones = response.data;    
    this.totalZonesRecords = response.meta['total'];
  }

  async loadContractProcessors() {
    if (!this.contract.id) return;

    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      include: ['processor']
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.contractProcessorsService.all(params));
    this.contractProcessors = response.data;
    
    let processorsIds = this.contractProcessors.filter((m:any) => !m.allCasesTypes).map((m: ContractProcessor) => m.processorId);
    let res = await firstValueFrom(this.casesTypesProcessorContractsService.all({page: {size: 0}, filter: FilterBuilder.fromObject({
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id),
      processorId: new Filter(FilterOperation.any, 'processorId', "", processorsIds)
    }).build(),include: ['caseType']}));
    this.contracsProcessorsCasessTypes = res.data;

  }

  showCaseTypesNames(id: any){
    var a = this.contracsProcessorsCasessTypes.filter((m:any) => m.contractProcessorId == id).map((m:any) => m.caseType.name).sort((x: string, y: string) => (x ?? '').localeCompare(y ?? ''));
    return a !=null ? a.join(", "): "--";

  }

  async loadContractWorkers() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      include: ['worker']
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.contractWorkersService.all(params));
    this.contractWorkers = response.data;

  }

  async loadContractCapabilities() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      //page: {size:0},
      include: ['capability']
    };

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.contractCapabilitiesService.all(params));
    this.contractCapabilities = response.data;
  }

  async loadContractInboundPhones() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractInboundPhonesService.all(params));
    this.contractInboundPhones = response.data
  }

  async loadContractOutboundPhones() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractOutboundPhonesService.all(params));
    this.contractOutboundPhones = response.data;
  }

  async loadContractInboundMails() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractInboundMailsService.all(params));
    this.contractInboundMails = response.data
  }

  async loadContractOutgoingMails() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['mailAccount']
    };

    let response = await firstValueFrom(this.contractOutgoingMailService.all(params));
    this.contractOutgoingMails = response.data
  }

  async loadContractSlas() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['caseEventType']
    };

    let response = await firstValueFrom(this.contractSlasService.all(params));
    this.contractSlas = response.data;
  }

  async loadContractTransactionSeries() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      //page: {size:0},
      include: ['transactionSerie.transactionType']
    };

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.contractTransactionSeriesService.all(params));
    this.contractTransactionSeries = response.data;
  }

  async loadBillingCompanies() {

    let response = await firstValueFrom(this.businessService.all({ page: { number: 1, size: 10 } }));
    this.billingCompanies = response.data;
  }

  async loadCostCenters(){
    let response = await firstValueFrom(this.costCentersService.all());
    this.costsCenters = response.data;
  }
  
  async loadIntegrations(){
    let response = await firstValueFrom(this.integrationService.all());
    this.integrations = response.data;    
    this.changeIntegration();
  }

  async loadContractMailAccounts() {
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractMailAccountsService.all(params));
    this.contractMailAccounts = response.data;
  }

  async loadBillingCompaniesBankAccounts() {

    let filters: any = {};
    if (this.contractFormGroup.value.billingCompanyId != "" && this.contractFormGroup.value.billingCompanyId != null) {      
      
      filters.companyId = new Filter(FilterOperation.equals, 'businessId', "", this.contractFormGroup.value.billingCompanyId)
    }

    let params: IParamsCollection = {
      page: { size: 0 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.businessBankAccountsService.all(params));    
    this.billingCompaniesBanksAccounts = response.data;
  }

  async loadUsers(event?: any) {
      let text = "";
    if (event != null) text = event.filter; 
    let filters = {
      name: new Filter(FilterOperation.contains, 'name', '', text),
      isWorker: new Filter(FilterOperation.equals, 'isWorker', '', false)   
    };
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.usersService.all(params));
    this.users = response.data;
  }

  async onChangeCompany(event: any) {
    this.loadBillingCompaniesBankAccounts();
  }


  async loadPaymentsMethods() {

    let response = await firstValueFrom(this.paymentsMethodsService.all({ page: { number: 1, size: 10 } }));
    this.paymentsMethods = response.data;

  }

  async loadRates() {
    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId', "", this.contract.companyId),
      contractId: new OrFilter([
        new Filter(FilterOperation.equals, 'contractId', "", this.contract.id),
        new Filter(FilterOperation.equals, 'contractId', "", null, true),
      ]),
      ratesDeleted: new Filter(FilterOperation.equals, "rate.deleted", '', false) 
    };

    let params: IParamsCollection = {
      include: ['rate']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.companyRatesServices.all(params));
    this.rates = response.data;

    //Buscamos si en la lista hay algun contract null
    /*let contractNull = response.data.find((m: any) => m.contractId == null);
    if (contractNull) {
      this.rates = response.data;
      //Quitamos repetidos
      this.rates = this.rates.filter((m: any, index: number, self: any) =>
        index === self.findIndex((t: any) => (
          t.rateId === m.rateId
        ))
      )
    } else {
      //Solo los que aparezca el contrato
      this.rates = response.data.filter((m: any) => m.contractId == this.contract.id);
      //Quitamos repetidos
      this.rates = this.rates.filter((m: any, index: number, self: any) =>
        index === self.findIndex((t: any) => (
          t.rateId === m.rateId
        ))
      )
    }*/


    this.totalRatesRecords = response.meta['total'];
  }

  async loadCasesLogsTypes(){

    var response = await firstValueFrom(this.caseLogTypesService.all());
    this.caseLogTypes = response.data;
    this.caseLogTypesFiltered = response.data;
    this.loadCaseLogTypesContract();
  }

  async loadCaseLogTypesContract(){
    var filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };
    var params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['caseLogType']
    };
    var response = await firstValueFrom(this.contractCaseLogsTypesService.all(params));

    this.caseLogTypesContract = response.data;
  }

  async loadCasesTypes(){
    //tramos todos los tipos de casos
    let response = await firstValueFrom(this.casesTypesService.all());
    var casesTypes = response.data;
    
    //tramos todos los tipos de casos
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contract.id)
    };    
    let params: IParamsCollection = { }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();
    let response2 = await firstValueFrom(this.contractCaseTypesService.all(params));
    this.contractCaseTypes = [];

    casesTypes.forEach((caseType: any) => {
      let contractCaseType = response2.data.find((m: any) => m.caseTypeId == caseType.id);
      var aux= {
        id: '00000000-0000-0000-0000-000000000000',
        caseType: caseType,
        daysGuarantes: null as number | null
      }
      if (contractCaseType) {
       aux.daysGuarantes = contractCaseType.daysGuarantes;
       aux.id = contractCaseType.id as string;
      } 
      this.contractCaseTypes.push(aux);
    })

  }

  saveContractCaseType(event: any)
  {
    
       let data: ContractCaseType = new ContractCaseType();
    if(event.index == '00000000-0000-0000-0000-000000000000'){
        data.caseTypeId = event.field.id;
        data.contractId = this.contract.id as string;
        data.daysGuarantes = event.data
    }else{
      data.id = event.index;
      data.caseTypeId = event.field.id;
      data.contractId = this.contract.id as string;
      data.daysGuarantes = event.data
    }
    this.contractCaseTypesService.save(data).subscribe({
      next: (data: any) => {
        this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de daño guardado correctamente." });
        this.loadCasesTypes();
      },
      error: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.contractFormGroup);
    if (valid) {
      if (!this.contract.id && this.pendingProcessors.length == 0) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Debe asignar al menos un tramitador al contrato." });
        return;
      }
      this.contract = Object.assign(this.contract, this.contractFormGroup.value);
      this.contract.integrationConfig = JSON.stringify(this.localModel);

      //Obtenemos todos los códigos para comparar al guardar
      let filters = {
        code: new Filter(FilterOperation.equals, 'code', "", this.contract.code)
      };
      let params: IParamsCollection = {
        //page: {size:0},
        filter: FilterBuilder.fromObject(filters).build()
      };

      let response = await firstValueFrom(this.contractsService.all(params));
      if (response.meta['total'] == 0 || this.contract.id == response.data[0].id) {
        
        //guardamos contract
        let contract = await firstValueFrom(this.contractsService.save(this.contract));

        try {
          await this.savePendingProcessors(contract.id!);
        } catch (error: any) {
          this.contract.id = contract.id;
          this.messageService.add({ closable: true, severity: 'error', detail: "El contrato se ha guardado, pero no todos los tramitadores. Revíselos y vuelva a guardar." });
          return;
        }

        if (this.contract.id != "undefined" && this.contract.id != "") {
          this.router.navigate(['companies/' + this.contract.companyId]);
        }

        this.messageService.add({ closable: true, severity: 'success', summary: "Contrato guardado correctamente." });
        this.loadContract(contract.id!);

      } else {
        this.messageService.add({ closable: true, severity: 'error', detail: "El código introducido ya existe" });
      }
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el contrato " + this.contract.name + "?",
      header: "Eliminar contrato",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractsService.delete(this.contract.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Contrato eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['companies/' + this.contract.companyId]);
  }


  editContractCapability(contractCapability: any) {
    let ref = this.dialogService.open(ContractCapabilitiesDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar especialidad del contrato',
      width: '500px',
      data: {
        contractCapabilityId: contractCapability ? contractCapability.id : null,
        contractId: this.contract.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractCapabilities();
    });
  }

  deleteContractCapability(contractCapability: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la especialiad del contrato?",
      header: "Eliminar especialidad",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractCapabilitiesService.delete(contractCapability.id).subscribe({
          next: (data: any) => {
            this.loadContractCapabilities();
            this.messageService.add({ closable: true, severity: 'success', detail: "Especialidad eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }


  editContractTransactionSerie(contractTransactionSerie: any) {
    let ref = this.dialogService.open(ContractTransactionSeriesDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar serie del contrato',
      width: '500px',
      data: {
        contractTransactionSerieId: contractTransactionSerie ? contractTransactionSerie.id : null,
        contractId: this.contract.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractTransactionSeries();
    });
  }

  deleteContractTransactionSerie(contractTransactionSerie: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la serie del contrato?",
      header: "Eliminar serie",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractTransactionSeriesService.delete(contractTransactionSerie.id).subscribe({
          next: (data: any) => {
            this.loadContractTransactionSeries();
            this.messageService.add({ closable: true, severity: 'success', detail: "Serie eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  editContractInboundPhone(contractInboundPhone: any) {
    let ref = this.dialogService.open(ContractInboundPhoneDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar teléfono',
      width: '500px',
      data: {
        contractId: this.contract.id,
        contractInboundPhoneId: contractInboundPhone ? contractInboundPhone.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractInboundPhones();
    });
  }

  deleteContractInboundPhone(contractInboundPhone: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el teléfono entrante  ?",
      header: "Eliminar teléfono",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractInboundPhonesService.delete(contractInboundPhone.id).subscribe({
          next: (data: any) => {
            this.loadContractInboundPhones();
            this.messageService.add({ closable: true, severity: 'success', detail: "Teléfono eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  editContractOutboundPhone(contractOutboundPhone: any) {
    let ref = this.dialogService.open(ContractOutboundPhoneDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar teléfono saliente',
      width: '500px',
      data: {
        contractId: this.contract.id,
        contractOutboundPhoneId: contractOutboundPhone ? contractOutboundPhone.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractOutboundPhones();
    });
  }

  deleteContractOutboundPhone(contractOutboundPhone: ContractOutboundPhone) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el teléfono saliente "+ contractOutboundPhone.phone +"?",
      header: "Eliminar teléfono",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractOutboundPhonesService.delete(contractOutboundPhone.id).subscribe({
          next: (data: any) => {
            this.loadContractOutboundPhones();
            this.messageService.add({ closable: true, severity: 'success', detail: "Teléfono eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  editContractInboundMail(contractInboundMail: any) {
    let ref = this.dialogService.open(ContractInboundMailDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar email',
      width: '500px',
      data: {
        contractId: this.contract.id,
        contractInboundMailId: contractInboundMail ? contractInboundMail.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractInboundMails();
    });
  }

  deleteContractInboundMail(contractInboundMail: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el email?",
      header: "Eliminar email",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractInboundMailsService.delete(contractInboundMail.id).subscribe({
          next: (data: any) => {
            this.loadContractInboundMails();
            this.messageService.add({ closable: true, severity: 'success', detail: "Email eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  
  editContractOutgoingMail(contractOutgoingMail: any) {
    let ref = this.dialogService.open(OutgoingMailDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar email',
      width: '50%',
      data: {
        contractId: this.contract.id,
        contractOutgoingMailId: contractOutgoingMail ? contractOutgoingMail.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractOutgoingMails();
    });
  }

  /*editContractCaseLog(contractCaseLog: any) {
    let ref = this.dialogService.open(ContractCaseLogDetailComponent, {
      closable: true,
      modal: true,
      header: 'Editar email',
      width: '50%',
      data: {
        contractId: this.contract.id,
        contractCaseLogId: contractCaseLog ? contractCaseLog.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadContractOutgoingMails();
    });
  }*/

  deleteContractOutgoingMail(contractOutgoingmail: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el email?",
      header: "Eliminar email",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractOutgoingMailService.delete(contractOutgoingmail.id).subscribe({
          next: (data: any) => {
            this.loadContractOutgoingMails();
            this.messageService.add({ closable: true, severity: 'success', detail: "Email eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  editContractZone(contractZone: any) {
    const ref = this.dialogService.open(ContractZonesDetailComponent, {
      closable: true,
      modal: true,
      data: {
        contractId: this.contract.id,
        id: contractZone.id
      },
      header: contractZone.id ? contractZone.name : "Nueva zona",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadContractZones();
    });

  }

  deleteContractZone(contractZone: ContractZone) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la zona " + (contractZone.zone  ? contractZone.zone.name : "") + "?",
      header: "Eliminar zona",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractZonesService.delete(contractZone.id).subscribe({
          next: (data: any) => {
            this.loadContractZones();
            this.messageService.add({ closable: true, severity: 'success', detail: "Zona eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  private refreshPendingProcessors() {
    this.contractProcessors = this.pendingProcessors.map(p => p.processor);
    this.contracsProcessorsCasessTypes = this.pendingProcessors.flatMap(p =>
      p.caseTypes.map((caseType: any) => ({ contractProcessorId: p.processor.id, caseType })));
  }

  editContractProcessor(contractProcessor: any) {

    const draft = this.contract.id ? null : this.pendingProcessors.find(p => p.processor.id == contractProcessor.id);
    const ref = this.dialogService.open(ContractProcessorsDetailComponent, {
      closable: true,
      modal: true,
      data: {
        contractId: this.contract.id,
        id: draft ? null : contractProcessor.id,
        draft,
        processorsIds: this.contractProcessors.map(m => m.processorId)
      },
      header: contractProcessor.id ? "Modificar tramitador" : "Nuevo tramitador",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      if (this.contract.id) {
        this.loadContractProcessors();
      } else if (data) {
        data.processor.id = draft ? draft.processor.id : crypto.randomUUID();
        const index = this.pendingProcessors.findIndex(p => p.processor.id == data.processor.id);
        if (index >= 0) this.pendingProcessors[index] = data; else this.pendingProcessors.push(data);
        this.refreshPendingProcessors();
      }
    });

  }

  private async savePendingProcessors(contractId: string) {
    while (this.pendingProcessors.length > 0) {
      const { processor, caseTypeIds } = this.pendingProcessors[0];
      processor.id = undefined;
      processor.contractId = contractId;
      const created = await firstValueFrom(this.contractProcessorsService.save(processor));
      for (const caseTypeId of caseTypeIds) {
        const caseTypeProcessorContract = new CaseTypeProcessorContract();
        caseTypeProcessorContract.caseTypeId = caseTypeId;
        caseTypeProcessorContract.processorId = processor.processorId;
        caseTypeProcessorContract.contractId = contractId;
        caseTypeProcessorContract.contractProcessorId = created.id as string;
        await firstValueFrom(this.casesTypesProcessorContractsService.save(caseTypeProcessorContract));
      }
      this.pendingProcessors.shift();
    }
  }

  deleteContractProcessor(contractProcessor: ContractProcessor) {
    if (!this.contract.id) {
      this.pendingProcessors = this.pendingProcessors.filter(p => p.processor.id != contractProcessor.id);
      this.refreshPendingProcessors();
      return;
    }
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar al tramitador " + contractProcessor.processor?.name + "?",
      header: "Eliminar tramitador",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractProcessorsService.delete(contractProcessor.id).subscribe({
          next: (data: any) => {
            this.loadContractProcessors();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tramitador eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }


  editContractWorker(contractWorker: any) {

    const ref = this.dialogService.open(ContractWorkersDetailComponent, {
      closable: true,
      modal: true,
      data: {
        contractId: this.contract.id,
        id: contractWorker.id,
        workersIds: this.contractWorkers.map(m => m.workerId)
      },
      header: contractWorker.id ? "Modificar operario preferente" : "Nuevo operario preferente",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadContractWorkers();
    });

  }

  deleteContractWorker(contractWorker: ContractWorker) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar al operario preferente?",
      header: "Eliminar operario preferente",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractWorkersService.delete(contractWorker.id).subscribe({
          next: (data: any) => {
            this.loadContractWorkers();
            this.messageService.add({ closable: true, severity: 'success', detail: "Operario preferente eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  editContractSla(contractSla: ContractSla | null) {
    const ref = this.dialogService.open(ContractSlasDetailComponent, {
      closable: true,
      modal: true,
      data: {
        contractId: this.contract.id,
        contractSlaId: contractSla ? contractSla.id : null
      },
      header: contractSla?.id ? "Modificar SLA" : "Nuevo SLA",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadContractSlas();
    });
  }

  deleteContractSla(contractSla: ContractSla) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el SLA?",
      header: "Eliminar SLA",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractSlasService.delete(contractSla.id).subscribe({
          next: (data: any) => {
            this.loadContractSlas();
            this.messageService.add({ closable: true, severity: 'success', detail: "SLA eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  editContractMailAccount(contractMailAccount: ContractMailAccount | null) {
    const ref = this.dialogService.open(ContractMailAccountsDetailComponent, {
      closable: true,
      modal: true,
      data: {
        contractId: this.contract.id,
        contractMailAccountId: contractMailAccount ? contractMailAccount.id : null
      },
      header: contractMailAccount?.id ? "Modificar cuenta de correo" : "Nueva cuenta de correo",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadContractMailAccounts();
    });
  }

  deleteContractMailAccount(contractMailAccount: ContractMailAccount) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la cuenta de correo?",
      header: "Eliminar cuenta de correo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractMailAccountsService.delete(contractMailAccount.id).subscribe({
          next: (data: any) => {
            this.loadContractMailAccounts();
            this.messageService.add({ closable: true, severity: 'success', detail: "Cuenta de correo eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }


  addCaseLogType(){
    this.caseLogTypeId = "";
    this.caseLogTypesFiltered = this.caseLogTypes.filter((m:any) => this.caseLogTypesContract.findIndex((model:any) => model.caseLogTypeId == m.id)== -1);
    this.displaycaseLogType = true;
  }

  async saveCaseLogType(){
    let caseLogTypeContract = new ContractCaseLogType();
    caseLogTypeContract.contractId = this.contract.id as string;
    caseLogTypeContract.caseLogTypeId = this.caseLogTypeId;

    await firstValueFrom(this.contractCaseLogsTypesService.save(caseLogTypeContract));
    this.loadCaseLogTypesContract();
    this.displaycaseLogType = false;
  }
  editCaseLogTypeFields(caseLogTypeContract: ContractCaseLogType){
    if(!this.allowCaseLogTypeFields) return;
    this.caseLogTypeFieldsEdit = caseLogTypeContract;
    this.caseLogTypeFieldsConfiguration = caseLogTypeContract.fieldsConfiguration ?? "";
    this.displayCaseLogTypeFields = true;
  }

  /**
   * Guarda el formulario propio del contrato para ese tipo de evento. Se valida que el JSON parsee:
   * uno inválido dejaría el tipo sin formulario sin avisar. Vacío significa usar el del tipo.
   */
  async saveCaseLogTypeFields(){
    if(this.caseLogTypeFieldsEdit == null || !this.allowCaseLogTypeFields) return;

    let configuration = this.caseLogTypeFieldsConfiguration.trim();
    if(configuration != ""){
      try {
        let parsed = JSON.parse(configuration);
        if(!Array.isArray(parsed?.fields)){
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El JSON de campos debe tener una propiedad 'fields' con una lista." });
          return;
        }
      } catch (error) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El JSON de campos no es válido." });
        return;
      }
    }

    this.caseLogTypeFieldsEdit.fieldsConfiguration = configuration == "" ? undefined : configuration;
    await firstValueFrom(this.contractCaseLogsTypesService.save(this.caseLogTypeFieldsEdit));
    this.messageService.add({ closable: true, severity: 'success', detail: "Campos guardados correctamente." });
    this.displayCaseLogTypeFields = false;
    this.caseLogTypeFieldsEdit = null;
    this.loadCaseLogTypesContract();
  }

  async deleteCaseLogType(caseLogTypeContract:any){
  this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la categoría de evento?",
      header: "Eliminar categoría de evento",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractCaseLogsTypesService.delete(caseLogTypeContract.id).subscribe({
          next: (data: any) => {
            this.loadCaseLogTypesContract();
            this.messageService.add({ closable: true, severity: 'success', detail: "Categoría de evento eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async changeIntegration(){
    var integration =  this.integrations.filter(m => m.id == this.contractFormGroup.value.integrationId);
    this.integration_config = integration.length > 0 ? this.parseIntegrationFields(integration[0]) : [];
    this.integration_groups = this.buildIntegrationGroups(this.integration_config);
    this.ensureIntegrationDefaults();
  }

  //los campos con "group" se pintan juntos en un card con ese nombre; los que no lo declaran van
  //sueltos en el sitio donde estan definidos. Un grupo que reaparece mas abajo cae en su card
  private buildIntegrationGroups(fields: IntegrationField[]): IntegrationFieldGroup[] {
    let groups: IntegrationFieldGroup[] = [];
    let groupsByName = new Map<string, IntegrationFieldGroup>();
    let loose: IntegrationFieldGroup | null = null;

    for (let field of fields) {
      let name = field.group?.trim();

      if (!name) {
        if (loose == null) {
          loose = { name: null, fields: [] };
          groups.push(loose);
        }
        loose.fields.push(field);
        continue;
      }

      //un campo agrupado corta la racha de sueltos: los siguientes abren un bloque nuevo
      loose = null;

      let group = groupsByName.get(name);
      if (group == null) {
        group = { name: name, fields: [] };
        groupsByName.set(name, group);
        groups.push(group);
      }
      group.fields.push(field);
    }

    return groups;
  }

  //el contrato puede tener integracion asignada sin haberla configurado nunca, o traer un json corrupto
  private parseIntegrationConfig(config: string | undefined): any {
    if (!config) {
      return {};
    }
    try {
      return JSON.parse(config) ?? {};
    } catch {
      return {};
    }
  }

  private parseIntegrationFields(integration: Integration): IntegrationField[] {
    try {
      return JSON.parse(integration.configuration)?.fields ?? [];
    } catch {
      return [];
    }
  }

  //los campos mail_account guardan un objeto anidado, hay que tenerlo creado antes de pintarlo.
  //solo rellenamos lo que falta: esto tambien se ejecuta al cambiar de integracion en el desplegable
  private ensureIntegrationDefaults() {
    for (let field of this.integration_config) {
      if (field.type != 'mail_account') {
        continue;
      }

      let value = this.localModel[field.code];
      if (value == null || typeof value !== 'object') {
        this.localModel[field.code] = emptyMailAccountValue();
        continue;
      }

      this.localModel[field.code] = Object.assign(emptyMailAccountValue(), value);
    }
  }

}
